import { render, staticRenderFns } from "./ActasLibrosObsequios.vue?vue&type=template&id=23072f12"
import script from "./ActasLibrosObsequios.vue?vue&type=script&lang=js"
export * from "./ActasLibrosObsequios.vue?vue&type=script&lang=js"
import style0 from "./ActasLibrosObsequios.vue?vue&type=style&index=0&id=23072f12&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports